export const getComponentStringMixin = {
    methods: {
        getComponentString (vnode) {
            if (!vnode) return false

            const getComponentsString = (vnodes) => vnodes.map(vn => this.getComponentString(vn)).filter(Boolean).join(' ')
            const getAttrsString = (attrs) => Object.entries(attrs).reduce((acc, [key, value]) => acc + ` ${key}='${value}' `, '')
            const getPropsString = (attrs) =>
                Object
                    .entries(attrs)
                    .reduce((acc, [key, value]) => {
                        let prefix = ''

                        if (typeof value === 'string') {
                            // eslint-disable-next-line no-useless-escape
                            value = value.replace(/\&quot\;/g, '"')
                        } else {
                            prefix = ':'
                        }

                        key = key.replace(/[A-Z]/g, (e) => '-' + e.toLowerCase())

                        return acc + ` ${prefix}${key}='${value}' `
                    }, '')

            if (Array.isArray(vnode)) return getComponentsString(vnode)

            if (vnode.tag === undefined && vnode.text) return vnode.text

            if (vnode.text === undefined && vnode.tag) {
                let result = ''
                let add = ''

                if (vnode.data && vnode.data.staticClass) add += ` class="${vnode.data.staticClass}" `
                if (vnode.data && vnode.data.attrs) add += getAttrsString(vnode.data.attrs)

                if (vnode.componentOptions) {
                    const vueComponent = vnode.componentOptions
                    let children = ''
                    let props = ''

                    if (Array.isArray(vueComponent.children)) children = getComponentsString(vueComponent.children)
                    if (vueComponent.propsData) props += getPropsString(vueComponent.propsData)

                    result += `<${vueComponent.tag} ${props} ${add}>${children}</${vueComponent.tag}>`
                } else {
                    let children = ''

                    if (Array.isArray(vnode.children)) children = getComponentsString(vnode.children)

                    result += `<${vnode.tag} ${add}>${children}</${vnode.tag}>`
                }

                return result
            }

            return false
        }
    }
}
